<script setup lang="ts">

import DetailedAudioPlayer from "@/components/UI/AudioPlayer/DetailedAudioPlayer.vue";

const props = defineProps<PlayerMetadata>();
import SplitPopup from "@/components/UI/Pupup/SplitPopup.vue";
import {computed, onMounted, onUnmounted} from "vue";
import BackgroundAudio, {PlayerMetadata} from "@/ts/Audio/BackgroundAudio";
import CDN from "@/ts/Utility/CDN";
import AudioRepository from "@/ts/Audio/Repository/AudioRepository";
import ImageZoomButton from "@/components/UI/Button/ImageZoomButton.vue";
import ImageViewer from "@/ts/ImageViewer/ImageViewer";

const backgroundAudio = BackgroundAudio.getInstance();
const {isPlaying} = backgroundAudio;
const iconName = computed(() => isPlaying.value ? 'pause' : 'play');


const onClick = () => {
  isPlaying.value ? backgroundAudio.pause() : backgroundAudio.play();
}
const onEnded = async () => {
  backgroundAudio.pause()
  const isMeditationListened = backgroundAudio.playerMetadata.value?.type === 'meditations';
  if(isMeditationListened) {
    await AudioRepository.saveMeditationListenedEvent(backgroundAudio.playerMetadata.value?.id!);
  }
}
const onCloseButtonClick = () => {
  backgroundAudio.stop();
}
onMounted(() => {
  backgroundAudio.addEventListener('ended', onEnded);
});
onUnmounted(() => {
  backgroundAudio.removeEventListener('ended', onEnded);
});
const onImageClick = () => {
  ImageViewer.getInstance().show(CDN.createUrl(props.image))
}
</script>

<template>
  <SplitPopup fixed-content-size @closeButtonClick="onCloseButtonClick" closeTheme="dark">
    <div class="audio-player__cover" @click="onImageClick">
      <img :src="CDN.createUrl(image)" alt="cover"/>
      <ImageZoomButton class="audio-player__action__zoom" theme="dark" />
    </div>
    <template #footer class="audio-player__footer">
      <div class="audio-player__footer">
        <DetailedAudioPlayer :image="image" :title="title" :audio="audio"/>
      </div>
    </template>
  </SplitPopup>
</template>

<style scoped lang="scss">
.audio-player {
  &__cover {
    width: 100%;
    height: 100%;
    position: relative;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__action{
    &__zoom {
      position: absolute;
      right: 20px;
      bottom: 20px;
    }
  }
  &__footer {
    height: 248px;
    width: 100%;
    display: flex;
    padding: 30px 40px 60px 40px;
    box-sizing: border-box;
    flex-direction: column;
  }

}
</style>
